export interface AgGridResponse {
  status: "success" | "fail";
  data: any;
  total: number;
}

export interface FilterParams {
  sort?: {
    orderBy?: string;
    isAscending?: boolean;
  };
  paginationParams?: {
    page: number;
    perPage: number;
  };
  search?: string;
  _timestamp?: number;
  note?: string;
  date?: {
    startedAt: string;
    endedAt: string;
  };
  label?: string[];
  status?: string[];
  source?: string[];
  [key: string]: any;
  byOrganization?: boolean;
  teams?: string[];
  teamMembers?: string[];
  isAssign?: boolean; // Flag to indicate "only show assigned leads" (used with teamMembers)
  products?: string[];
  _productNames?: { [productId: string]: string }; // For storing product names
  activityFilter?: {
    types?: string[];
    range?: {
      start: string;
      end: string;
    };
    duration?: number;
    durationOperator?: string; // "eq", "gt", "lt" - Add this explicitly
    callCount?: number;
    callCountOperator?: string; // "eq", "gt", "lt" - Add this explicitly
  };
  taskFilter?: {
    type: string;
    range: {
      start: string;
      end: string;
    };
  };
  list?: string;
  isUntouched?: boolean;
  isNotCalled?: boolean;
  isDuplicate?: boolean;
  isFollowUp?: boolean;
  isNotAssign?: boolean;
  isStaled?: boolean;
  isIgnoreList?: boolean;
  quickFilter?: 'recent_assign_leads' | 'today_task' | 'over_due_task' | 'recent_call';
  customFieldFilter?: {
    fieldName: string;
    single: {
      operator: string;
      value: string;
    };
    range: {
      start: {
        operator: string;
        value: string;
      };
      end: {
        operator: string;
        value: string;
      };
    };
  };
}

export interface UserDetails {
  search?: string;
  name?: string;
}

export const advanceFilterKeys = [
  "sort",
  "search",
  "note",
  "date",
  "label",
  "status",
  "source",
  "byOrganization",
  "teams",
  "teamMembers",
  "isAssign",
  "activityFilter",
  "taskFilter",
  "isUntouched",
  "isNotCalled",
  "isFollowUp",
  "isNotAssign",
  "customFieldFilter",
  'isStaled',
  'isDuplicate',
  'products',
  'isIgnoreList',
  'quickFilter'
];
